// extracted by mini-css-extract-plugin
module.exports = {"cart__wrapp":"f_q"};